import {
  CadastralParcelFeatureDto,
  EtxeApiPrefixes,
  EtxeApiSlugs,
  GouvDpeDto,
  GouvDvfDataDto,
  GouvGeorisquesDto,
  PropertyCadastralDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCachedConnector } from '../../../../../api-cached-connector.abstract-service';
import { ApiCaller } from '../../../../../api-caller.service';

export class GouvConnector extends ApiCachedConnector {
  private slug = EtxeApiSlugs.GOUV;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {
    super();
  }

  dpe(query: string): Observable<GouvDpeDto | null> {
    const endpoint = `${this.slug}/dpe?numeroDpe=${query}`;

    return this.getCached(endpoint, () =>
      this.apiCaller.getRequest<GouvDpeDto | null>(EtxeApiPrefixes.PUBLIC, endpoint),
    );
  }

  georisques(latlon?: string, adresse?: string, codeInsee?: string): Observable<GouvGeorisquesDto> {
    const params = new URLSearchParams();
    if (latlon) params.append('latlon', latlon);
    if (codeInsee) params.append('code_insee', codeInsee || '');
    if (adresse) params.append('adresse', adresse);

    const endpoint = `${this.slug}/georisques?${params.toString()}`;

    return this.getCached(endpoint, () =>
      this.apiCaller.getRequest<GouvGeorisquesDto>(EtxeApiPrefixes.PUBLIC, endpoint),
    );
  }

  dvf(codeInsee: string, propertyType: string, lat?: number, lon?: number): Observable<GouvDvfDataDto> {
    const params = new URLSearchParams();
    params.append('code_insee', codeInsee);
    params.append('property_type', propertyType);
    if (lat != null) params.append('lat', lat.toString());
    if (lon != null) params.append('lon', lon.toString());

    const endpoint = `${this.slug}/dvf?${params.toString()}`;

    return this.getCached(endpoint, () =>
      this.apiCaller.getRequest<GouvDvfDataDto>(EtxeApiPrefixes.PUBLIC, endpoint),
    );
  }

  cadastreSurrounding(lat: number, lng: number, radius = 25): Observable<CadastralParcelFeatureDto[]> {
    const params = new URLSearchParams();
    params.append('lat', lat.toString());
    params.append('lng', lng.toString());
    if (radius != null) params.append('radius', radius.toString());

    const endpoint = `${this.slug}/cadastre/surrounding?${params.toString()}`;

    return this.getCached(endpoint, () =>
      this.apiCaller.getRequest<CadastralParcelFeatureDto[]>(EtxeApiPrefixes.PUBLIC, endpoint),
    );
  }

  cadastreParcelByRef(
    reference: string,
    codeInsee?: string,
    lat?: number,
    lng?: number,
  ): Observable<CadastralParcelFeatureDto | null> {
    const params = new URLSearchParams();
    params.append('reference', reference);
    if (codeInsee) params.append('codeInsee', codeInsee);
    if (lat != null) params.append('lat', lat.toString());
    if (lng != null) params.append('lng', lng.toString());

    const endpoint = `${this.slug}/cadastre/parcel-by-ref?${params.toString()}`;

    return this.getCached(endpoint, () =>
      this.apiCaller.getRequest<CadastralParcelFeatureDto | null>(EtxeApiPrefixes.PUBLIC, endpoint),
    );
  }

  cadastreParcel(lat: number, lng: number): Observable<PropertyCadastralDto | null> {
    const params = new URLSearchParams();
    params.append('lat', lat.toString());
    params.append('lng', lng.toString());

    const endpoint = `${this.slug}/cadastre/parcel?${params.toString()}`;

    return this.getCached(endpoint, () =>
      this.apiCaller.getRequest<PropertyCadastralDto | null>(EtxeApiPrefixes.PUBLIC, endpoint),
    );
  }
}
